'use client';

import { Skeleton } from '@mui/material';
import { FC, ReactNode } from 'react';
import {
  StatCardLabel,
  StatCardTopRow,
  StatCardValue,
  StatCardWrapper,
  StatIconPlaceholder,
} from '../styled';

type DashboardStatCardProps = {
  icon: ReactNode;
  label: string;
  value: string;
  isLoading?: boolean;
};

export const DashboardStatCard: FC<DashboardStatCardProps> = ({
  icon,
  label,
  value,
  isLoading,
}) => (
  <StatCardWrapper>
    <StatCardTopRow>
      <StatIconPlaceholder>{icon}</StatIconPlaceholder>
    </StatCardTopRow>

    {isLoading ? (
      <Skeleton variant="rounded" width={80} height={34} animation="wave" />
    ) : (
      <StatCardValue>{value}</StatCardValue>
    )}
    <StatCardLabel>{label}</StatCardLabel>
  </StatCardWrapper>
);
